import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "sm:hidden",
  id: "tabs-select"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "tabs",
  class: "sr-only"
}, "Select a tab", -1)
const _hoisted_4 = ["value", "selected", "onChange"]
const _hoisted_5 = { class: "hidden sm:block" }
const _hoisted_6 = { class: "border-b border-gray-200" }
const _hoisted_7 = {
  class: "flex space-x-8",
  "aria-label": "Tabs"
}
const _hoisted_8 = ["onClick", "aria-current"]

import {
		ref,
		PropType
	} from 'vue'

	interface tab {
		current: boolean,
		name: string
	}

	
// name the component
	const __default__ = { name: 'TwTabsUnderline' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		tabs: {
			type: Array as PropType<Array<tab>>,
			default: () => {return []}
		}
	},
  setup(__props, { expose: __expose }) {


	const props = __props
	

	const _tabs = ref<tab[]>(props.tabs)

	function changeTab(i: number) {
		_tabs.value.forEach(tab => {tab.current = false})
		
		_tabs.value[i].current = true
	}

	__expose({
		_tabs
	})

return (_ctx: any,_cache: any) => {
  return (_tabs.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("select", {
            id: "tabs",
            name: "tabs",
            class: "block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand-500 focus:outline-none focus:ring-brand-500 sm:text-sm",
            onChange: _cache[0] || (_cache[0] = (e) => changeTab(e.target.value))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_tabs.value, (tab, i) => {
              return (_openBlock(), _createElementBlock("option", {
                value: i,
                key: tab.name,
                selected: tab.current,
                onChange: (e) => changeTab(i)
              }, _toDisplayString(tab.name), 41, _hoisted_4))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("nav", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_tabs.value, (tab, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: tab.name,
                  onClick: ($event: any) => (changeTab(i)),
                  class: _normalizeClass(["cursor-pointer", [tab.current ? 'border-brand-500 text-brand-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium']]),
                  "aria-current": tab.current ? 'page' : undefined
                }, _toDisplayString(tab.name), 11, _hoisted_8))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})